
// @ts-nocheck


export const localeCodes =  [
  "ca/fr",
  "ca/en",
  "qc/fr",
  "qc/en",
  "intl/en",
  "intl/fr",
  "us/en"
]

export const localeLoaders = {
  "ca/fr": [],
  "ca/en": [],
  "qc/fr": [],
  "qc/en": [],
  "intl/en": [],
  "intl/fr": [],
  "us/en": []
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "ca/fr",
      language: "fr-CA",
      files: []
    },
    {
      code: "ca/en",
      language: "en-CA",
      files: []
    },
    {
      code: "qc/fr",
      language: "fr-CA",
      files: []
    },
    {
      code: "qc/en",
      language: "en-CA",
      files: []
    },
    {
      code: "intl/en",
      language: "en-GB",
      files: []
    },
    {
      code: "intl/fr",
      language: "fr-FR",
      files: []
    },
    {
      code: "us/en",
      language: "en-US",
      files: []
    }
  ],
  defaultLocale: "",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: true,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "config",
  pages: {
    "news/index": {
      "ca/fr": "/nouvelles",
      "ca/en": "/news",
      "qc/fr": "/nouvelles",
      "qc/en": "/news",
      "intl/en": "/news",
      "intl/fr": "/nouvelles",
      "us/en": "/news"
    },
    "news/[slug]": {
      "ca/fr": "/nouvelles/[slug]",
      "ca/en": "/news/[slug]",
      "qc/fr": "/nouvelles/[slug]",
      "qc/en": "/news/[slug]",
      "intl/en": "/news/[slug]",
      "intl/fr": "/nouvelles/[slug]",
      "us/en": "/news/[slug]"
    },
    "our-brands/[slug]": {
      "ca/fr": "/nos-marques/[slug]",
      "ca/en": "/our-brands/[slug]",
      "qc/fr": "/nos-marques/[slug]",
      "qc/en": "/our-brands/[slug]",
      "intl/en": "/our-brands/[slug]",
      "intl/fr": "/nos-marques/[slug]",
      "us/en": "/our-brands/[slug]"
    }
  },
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "ca/fr",
    language: "fr-CA",
    files: []
  },
  {
    code: "ca/en",
    language: "en-CA",
    files: []
  },
  {
    code: "qc/fr",
    language: "fr-CA",
    files: []
  },
  {
    code: "qc/en",
    language: "en-CA",
    files: []
  },
  {
    code: "intl/en",
    language: "en-GB",
    files: []
  },
  {
    code: "intl/fr",
    language: "fr-FR",
    files: []
  },
  {
    code: "us/en",
    language: "en-US",
    files: []
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/